import "../../../resources/less/Admin/Licences/AddLicenceSchool.less";
import TelephoneInput from "../Contact/TelephoneInput";
import NanomonxForm from "../../components/Forms/NanomonxForm";

class AddLicenceSchool {
  private readonly requestQuoteContainer: JQuery<HTMLElement>;
  private readonly quoteFormContainer: JQuery<HTMLElement>;
  private readonly durationOptions: JQuery<HTMLElement>;
  private readonly school: JQuery<HTMLElement>;
  private readonly schoolContainer: JQuery<HTMLElement>;
  private oneYearOption: JQuery<HTMLElement>;
  private threeYearOption: JQuery<HTMLElement>;
  private readonly durationContainer: JQuery<HTMLElement>;
  private readonly durationSummary: JQuery<HTMLElement>;
  private readonly durationSelection: JQuery<HTMLElement>;
  private schoolSummary: JQuery<HTMLElement>;
  private schoolSelection: JQuery<HTMLElement>;

  constructor() {
    this.requestQuoteContainer = $("#request-quote-school");
    this.quoteFormContainer = $(".request-quote-frm");
    new NanomonxForm({
      elementName: "quote_form_school",
      submitClass: ".quote-form-school-submit",
    });
    new TelephoneInput(
      this.quoteFormContainer.find(
        ".field-telephone",
      ) as JQuery<HTMLInputElement>,
    );

    this.school = $(".school-type");
    this.schoolContainer = $(".school-type-container");
    this.schoolSummary = this.schoolContainer.find(".option-summary");
    this.schoolSelection = this.schoolContainer.find(".option-selection");

    this.durationOptions = $(".duration-option");
    this.oneYearOption = this.durationOptions.filter(".option-1y");
    this.threeYearOption = this.durationOptions.filter(".option-3y");
    this.durationContainer = $(".sub-duration-container");
    this.durationSummary = this.durationContainer.find(".option-summary");
    this.durationSelection = this.durationContainer.find(".option-selection");

    // School size selection
    this.school.on("click", (ev) => {
      this.updateSchoolType($(ev.currentTarget));
      $(window).scrollTop($(this.requestQuoteContainer).offset().top);
    });

    // Subscription duration selection
    this.durationOptions.on("click", (ev) => {
      this.updateDuration($(ev.currentTarget));
      $(window).scrollTop($(this.requestQuoteContainer).offset().top);
    });

    // School size modification
    $(".school-type-modify").on("click", () => {
      this.editSchoolType();
    });

    // Subscription duration modification
    $(".sub-duration-modify").on("click", () => {
      this.editDuration();
    });
  }

  private updateSchoolType(currentOption: JQuery<HTMLElement>): void {
    const optionTitle = currentOption.find(".item-title").text();
    const optionDesc = currentOption.find(".item-desc").text();
    const { subDesc, subOneYearPrice, subThreeYearPrice } =
      currentOption[0].dataset;

    // hidden field population
    $("#quote_form_school_schoolSize").val(optionTitle);

    this.school.removeClass("selected");
    currentOption.addClass("selected");

    this.schoolSummary.find(".item-title").text(optionTitle);
    this.schoolSummary.find(".item-desc").text(optionDesc);

    this.oneYearOption.find(".item-desc").text(subDesc);
    this.oneYearOption.find(".item-price").text(subOneYearPrice);
    this.threeYearOption.find(".item-price").text(subThreeYearPrice);

    this.schoolSummary.slideDown("slow");
    this.schoolSelection.slideUp("slow");
    this.durationSelection.slideDown("slow");
  }

  private updateDuration(currentOption: JQuery<HTMLElement>): void {
    const optionTitle = currentOption.find(".item-title").text();
    const optionDesc = currentOption.find(".item-desc").text();
    const optionPrice = currentOption.find(".item-price").text();

    // hidden field population
    $("#quote_form_school_subDuration").val(optionTitle);

    $(".duration-option").removeClass("selected");
    currentOption.addClass("selected");

    this.durationSummary.find(".item-title .text").text(optionTitle);
    this.durationSummary.find(".item-title .price").text(optionPrice);
    this.durationSummary.find(".item-desc").text(optionDesc);

    this.durationSelection.slideUp("slow");
    this.durationSummary.slideDown("slow");
    this.quoteFormContainer.slideDown("slow");
  }

  private editSchoolType(): void {
    this.school.removeClass("selected");
    this.durationContainer.find(".duration-option").removeClass("selected");

    this.schoolSummary.slideUp("slow");
    this.durationSummary.slideUp("slow");
    this.durationSelection.slideUp("slow");
    this.schoolSelection.slideDown("slow");
    this.quoteFormContainer.slideUp("slow");
  }

  private editDuration(): void {
    this.durationOptions.removeClass("selected");
    $(".sub-duration-container .option-summary:visible").slideUp("slow");
    this.durationSelection.slideDown("slow");
    this.quoteFormContainer.slideUp("slow");
  }
}

$(window).on("load", () => {
  new AddLicenceSchool();
});
